import { render, staticRenderFns } from "./businessInformation.vue?vue&type=template&id=426ef84a&scoped=true&"
import script from "./businessInformation.vue?vue&type=script&lang=js&"
export * from "./businessInformation.vue?vue&type=script&lang=js&"
import style0 from "./businessInformation.vue?vue&type=style&index=0&id=426ef84a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426ef84a",
  null
  
)

export default component.exports